/**
 * Microsoft Entra ID (MSAL) configuration for admin portal SSO.
 */
import {
  PublicClientApplication,
  type Configuration,
  LogLevel,
} from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined;

export function buildMsalConfig(tenant?: string, client?: string): Configuration | null {
  const tid = tenant ?? tenantId;
  const cid = client ?? clientId;
  if (!tid?.trim() || !cid?.trim()) {
    return null;
  }
  const authority = `https://login.microsoftonline.com/${tid.trim()}`;
  const redirectUri =
    import.meta.env.VITE_ENTRA_REDIRECT_URI?.trim() ||
    `${window.location.origin}/auth/callback`;

  return {
    auth: {
      clientId: cid.trim(),
      authority,
      redirectUri,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    },
    cache: {
      cacheLocation: "sessionStorage",
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
      },
    },
  };
}

let msalInstance: PublicClientApplication | null = null;

export function getMsalInstance(config?: Configuration): PublicClientApplication | null {
  const cfg = config ?? buildMsalConfig();
  if (!cfg) return null;
  if (!msalInstance || config) {
    msalInstance = new PublicClientApplication(cfg);
  }
  return msalInstance;
}

export const entraLoginRequest = {
  scopes: ["openid", "profile", "email"],
};
